<template>
  <div>
    <!--背景图片-->
    <div style="position:relative;">
      <img alt="" src="../../../../assets/img/resume/个人简历背景-不带图标1.png" style="height: 250px; width: 100%; ">
      <div style="position:absolute; top:100px; left: 38%">
        <div style=" margin: 0 auto;">
          <img alt="" v-if="isAc === '0'" src="../../../../assets/img/resume/个人简历图标-2.png" style="height: 80px;">
        </div>
      </div>
    </div>

    <div style="background-color: #FFF;">

      <div v-if="isAc === '0'" style="height: 30px">
        <span class="bsicInfoTitle1">经销商:</span><span>{{orgName}}</span><span
              class="bsicInfoTitle1">职位:</span><span>{{jobName}}</span>
      </div>

      <!--基本信息-->
      <div style="width: 98%; margin:0 auto; ">
        <el-card style="border-color: #2763af;">
          <div slot="header">
            <p><em class="baseinfoico"></em> <span class="bsicInfo">{{$t('talentpool.basicInfo')}}</span></p>
          </div>
          <div>
            <el-form label-position="top" :data="dataForm" :rules="dataListRules" :model="dataForm"
                     ref="dataForm">
              <el-col :span="20">
                <el-row class="row-mar-l">
                  <!--姓名-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.name')" prop="name">
                      <el-input v-model.trim="dataForm.name" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>

                  <!--性别-->
                  <el-col :span="6">
                    <el-form-item :label="$t('user.gender')" prop="gender">
                      <el-select v-model="dataForm.gender" :disabled="true">
                        <el-option label="男" value="10"></el-option>
                        <el-option label="女" value="20"></el-option>
                      </el-select>
                    </el-form-item>
                    <!--											<el-select v-model="dataForm.gender">-->
                    <!--												<el-option v-for="(item,index) in sexCode"-->
                    <!--																	 :key="index"-->
                    <!--																	 :label="item.name"-->
                    <!--																	 :value="item.code">-->
                    <!--												</el-option>-->
                    <!--											</el-select>-->
                    <!--										</el-form-item>-->
                  </el-col>

                  <!--出生日期-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.birthday')" prop="birthday">
                      <el-date-picker v-model="dataForm.birthday"
                                      :disabled="true"
                                      type="date"
                                      :editable="false"
                                      value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>

                  <!--证件类刑-->
                  <el-col :span="6">
                    <el-form-item :label="$t('user.idtype')" prop="idType">
                      <el-select v-model="dataForm.idType"
                                 :disabled="true"
                                 clearable>
                        <el-option v-for="(item,index) in idType"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row class="row-mar-l">
                  <!-- 证件编号-->
                  <el-col :span="6">
                    <el-form-item :label="$t('user.passportIdcard')" prop="idNo">
                      <el-input v-model.trim="dataForm.idNoT"
                                :disabled="true"
                                maxlength="18"></el-input>
                    </el-form-item>
                  </el-col>

                  <!--最高学历 -->
                  <el-col :span="6">
                    <el-form-item :label="$t('user.education')"
                                  prop="education">
                      <el-select v-model="dataForm.education"
                                 :disabled="true"
                                 clearable>
                        <el-option v-for="(item,index) in educationCode"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <!-- 目前居住省份/城市-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.liveName')" prop="liveName">
                      <class-tree ref="cityClassRef"
                                  v-on:getSelectList="getcitySelectList"
                                  v-bind:defaultProps="citydefaultProps"
                                  v-bind:isOpen=false
                                  v-bind:url="queryCityTreeUrl"
                                  v-bind:showArray="dataForm.liveArr"
                                  v-bind:showValue="dataForm.liveName"
                                  v-on:clearTreeInfo="cityclassInfo"
                                  v-bind:listName="'city'"
                                  v-bind:isSelect=true></class-tree>
                      <!--                      <class-tree ref="cityclassRef"-->
                      <!--                                  v-on:getSelectList="getcitySelectList2"-->
                      <!--                                  v-bind:defaultProps="citydefaultProps"-->
                      <!--                                  v-bind:isOpen=false-->
                      <!--                                  v-bind:url="queryCityTreeUrl"-->
                      <!--                                  v-bind:isSelect=true-->
                      <!--                                  v-bind:showValue="dataForm.liveName"-->
                      <!--                                  v-on:clearTreeInfo="cityclassInfo2"-->
                      <!--                                  v-bind:listName="'city'"></class-tree>-->
                    </el-form-item>
                  </el-col>

                  <!-- 户口所在省份/城市-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.registeredResidenceName')">
                      <class-tree ref="cityClassRef2"
                                  v-on:getSelectList="getcitySelectList2"
                                  v-bind:defaultProps="citydefaultProps"
                                  v-bind:isOpen=false
                                  v-bind:url="queryCityTreeUrl"
                                  v-bind:showArray="dataForm.registeredResidenceArr"
                                  v-bind:showValue="dataForm.registeredResidenceName"
                                  v-on:clearTreeInfo="cityclassInfo2"
                                  v-bind:listName="'city'"
                                  v-bind:isSelect=true></class-tree>
                      <!--                      <class-tree ref="cityclassRef"-->
                      <!--                                  v-on:getSelectList="getcitySelectList"-->
                      <!--                                  v-bind:defaultProps="citydefaultProps"-->
                      <!--                                  v-bind:isOpen=false-->
                      <!--                                  v-bind:url="queryCityTreeUrl"-->
                      <!--                                  v-bind:isSelect=true-->
                      <!--                                  v-bind:showValue="dataForm.registeredResidenceName"-->
                      <!--                                  v-on:clearTreeInfo="cityclassInfo"-->
                      <!--                                  v-bind:listName="'city'"></class-tree>-->
                    </el-form-item>
                  </el-col>


                </el-row>

                <el-row class="row-mar-l">

                  <!--民族 nation -->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.nationName')">
                      <el-select v-model="dataForm.nation"
                                 clearable>
                        <el-option v-for="(item,index) in nation"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <!-- 国籍-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.nationality')" prop="nationality">
                      <el-select v-model="dataForm.nationality"
                                 clearable>
                        <el-option v-for="(item,index) in nationality"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <!-- 籍贯-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.native')">
                      <class-tree ref="cityClassRef3"
                                  v-on:getSelectList="getcitySelectList3"
                                  v-bind:defaultProps="citydefaultProps"
                                  v-bind:isOpen=false
                                  v-bind:url="queryCityTreeUrl"
                                  v-bind:showArray="dataForm.nativePlaceArr"
                                  v-bind:showValue="dataForm.nativePlaceName"
                                  v-on:clearTreeInfo="cityclassInfo3"
                                  v-bind:listName="'city'"
                                  v-bind:isSelect=true></class-tree>
                    </el-form-item>
                  </el-col>

                  <!--占位符-->
                  <el-col :span="6">
                    <el-form-item></el-form-item>
                  </el-col>

                </el-row>
                <el-row class="row-mar-l">

                  <!-- 手机-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.phone')" prop="telT">
                      <el-input v-model.trim="dataForm.telT" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>

                  <!-- 邮箱-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.mail')" prop="mailT">
                      <el-input v-model.trim="dataForm.mailT"
                                :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>

                  <!-- 微信号-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.wechatNo')">
                      <el-input v-model.trim="dataForm.wechatNo" maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>

                  <!-- 参加工作年份-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.firstWorkYear')" prop="firstWorkYear">
                      <el-date-picker v-model="dataForm.firstWorkYear"
                                      type="year"
                                      placeholder=""
                                      :editable="false"
                                      :picker-options="pickerOptions"
                                      value-format="yyyy">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>


                </el-row>
                <el-row class="row-mar-l">
                  <!-- 所属经销商网点-->
                  <el-col :span="6">
                    <el-form-item :label="$t('user.outlet')">
                      <el-input v-model.trim="dataForm.orgName" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>

                  <!-- 当前主要职位-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.majorPositions')">
                      <el-input v-model.trim="dataForm.job" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>

                  <!-- 服务宝马网络开始日期-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.bmwJoinDate')">
                      <el-date-picker v-model="dataForm.bmwJoinDate"
                                      :disabled="true"
                                      type="date"
                                      :editable="false"
                                      placeholder=""
                                      value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>

                  <!-- 加入经销商网点日期-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.workJoinDate')">
                      <el-date-picker v-model="dataForm.networkJoinDate"
                                      :disabled="true"
                                      :editable="false"
                                      type="date"
                                      placeholder=""
                                      value-format="yyyy-MM-dd">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>


                </el-row>
                <el-row class="row-mar-l">
                  <!-- 工龄-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.workYearsss')">
                      <el-input v-model.trim="dataForm.workYears" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>

                  <!-- 宝龄-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.bmwYearss')">
                      <el-input v-model.trim="dataForm.bmwAgeYear" :disabled="true"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="4">
                <!--                <img alt="" src="../../../../assets/img/user.jpg"-->
                <!--                     style="width: 100%; max-width: 100%;max-height: 100%; "/>-->
                <div class="img-div"
                     @click="modifyImg">
                  <img alt="" :src="dataForm.headurl"/>
                  <div class="modify-img"
                       v-show="headModifyShow">
                    {{$t('user.userImg')}}
                  </div>
                </div>
              </el-col>

            </el-form>
            <!--            <el-button type="primary" @click="onCheckInfoFrom">测试验证</el-button>-->
          </div>
        </el-card>
      </div>

      <!--位符-->
      <div style="height: 50px"></div>

      <!--个人评价-->
      <div style="width: 98%; margin:0 auto; ">
        <el-card style="border-color: #2763af;">
          <div slot="header">
            <p><em class="personalEvaluate"></em> <span class="bsicInfo">{{$t('talentpool.personalValuation')}}</span>
            </p>
          </div>
          <div>
            <el-form label-position="top">
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('talentpool.personalValuation')">
                  </el-form-item>
                </el-col>
                <el-input v-model="dataForm.personalEvaluation" type="textarea" :maxlength="500"
                          show-word-limit
                          :rows="4"
                          placeholder="请输入个人评价（限输入500字)"></el-input>
              </el-row>
              <!--占位符-->
              <div style="height: 50px"></div>
            </el-form>

          </div>
        </el-card>
      </div>

      <!--位符-->
      <div style="height: 50px"></div>

      <!--工作经历-->
      <div style="width: 98%; margin:0 auto; ">
        <el-card style="border-color: #2763af;">
          <div slot="header">
            <p>
              <em class="workExperience"></em>
              <span class="bsicInfo">工作经历</span>
              <span style="float: right; padding: 3px 0; margin-right: 30px;cursor: pointer;" class="bsicInfo"
                    @click="onAddworkExperienceFrom">添加工作经历</span>
              <em class="addToButton" style="float: right; padding: 3px 0; margin-right: 10px;cursor: pointer;"
                 @click="onAddworkExperienceFrom"></em>
            </p>

          </div>
          <div>
            <el-form label-position="top" :model="workExperienceFrom" ref="workExperienceFrom">
              <div v-for="(itemWork,index) in workExperienceFrom.workExperience_list">

                <!--删除按钮-->
                <div style="cursor: pointer;display: inline-block;"
                     v-show="itemWork.row1 !== 1"
                     @click="deleteworkExperienceFrom(itemWork)"><em class="el-icon-remove"
                                                                    style="color : red;">删除本项</em>
                </div>
                <br>

                <el-row>
                  <!--所属行业 -->
                  <el-col :span="6">
                    <el-form-item label="所属行业"
                                  :prop="'workExperience_list.' + index + '.industryType'"
                                  :rules="[{ required: true, message: '所属行业不能为空',trigger: 'blur'}]">
                      <el-radio-group v-model="itemWork.industryType" @change="checkBrandCode(itemWork,index)">
                        <el-radio label="10">汽车</el-radio>
                        <el-radio label="20">其他</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>

                  <!--品牌 -->
                  <el-col :span="6">
                    <el-form-item
                            :label="$t('talentpool.brandCode')"
                            :prop="'workExperience_list.' + index + '.brandCode'"
                            :rules="[{ required: true, message: '品牌不能为空',trigger: 'blur'}]"
                            v-if="itemWork.industryType === '10'">
                      <el-select clearable v-model="itemWork.brandCode" placeholder="请选择品牌" @change="checkBrandCode2(itemWork,index)">
                        <el-option v-for="(item,index) in workBrand"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <!-- 品牌名称 -->
                  <el-col :span="6">
                    <el-form-item
                            label="所选行业"
                            :prop="'workExperience_list.' + index + '.industry'"
                            :rules="[{ required: true, message: '所选行业不能为空',trigger: 'blur'}]"
                            v-if="itemWork.industryType === '20'"
                    >
                      <el-select clearable v-model="itemWork.industry" placeholder="请选择所选行业">
                        <el-option v-for="(item,index) in industry"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <!--品牌名称 -->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.brandCodeName')"
                                  :prop="'workExperience_list.' + index + '.otherBrandCodeName'"
                                  :rules="[{ required: true, message: '品牌名称不能为空',trigger: 'change'}]"
                                  v-if="itemWork.industryType === '10' && itemWork.brandCode ==='90'"
                    >
                      <el-input v-model.trim="itemWork.otherBrandCodeName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div style="height: 5px"></div>
                <el-row>

                  <!--公司 -->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.company')"
                                  :prop="'workExperience_list.' + index + '.company'"
                                  :rules="[{ required: true, message: '公司不能为空',trigger: 'change'}]"
                    >
                      <el-input v-model.trim="itemWork.company" maxlength="200"></el-input>
                    </el-form-item>
                  </el-col>

                  <!--职位 -->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.job')"
                                  :prop="'workExperience_list.' + index + '.job'"
                                  :rules="[{ required: true, message: '职位不能为空',trigger: 'change'}]"
                    >
                      <el-input v-model.trim="itemWork.job" maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>

                  <!--开始时间-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.startDate')"
                                  :prop="'workExperience_list.' + index + '.startDate'"
                                  :rules="[{ required: true, message: '时间不能为空',trigger: 'change'}]"
                    >
                      <el-date-picker v-model="itemWork.startDate"
                                      :editable="false"
                                      type="month"
                                      placeholder=""
                                      format="yyyy-MM"
                                      value-format="yyyy-MM"
                                      :picker-options="pickerOptions"
                                      @change="changeEnd(itemWork,index)">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>

                  <!--结束时间-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.endDate')">
                      <el-date-picker v-model="itemWork.endDate"
                                      :editable="false"
                                      type="month"
                                      placeholder="至今"
                                      format="yyyy-MM"
                                      value-format="yyyy-MM-dd"
                                      :picker-options="pickerOptions"
                                      @change="changeStart(itemWork,index)">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>

                <div style="height: 5px"></div>
                <el-row>
                  <el-col :span="24">
                    <el-form-item :label="$t('talentpool.jobDescription')"
                                  :prop="'workExperience_list.' + index + '.jobDescription'"
                                  :rules="[{ required: true, message: '描述不能为空',trigger: 'change'}]"
                                  style="height: 40px">
                    </el-form-item>
                  </el-col>
                  <el-input v-model.trim="itemWork.jobDescription" type="textarea" :maxlength="200"
                            show-word-limit :rows="4"
                            change="jobDescriptionChange(index)"
                            placeholder="请输入工作描述与职责（限输入200字)"></el-input>
                </el-row>
                <!--占位符-->
                <div style="height: 50px"></div>
                <div style="height: 50px"></div>
              </div>
            </el-form>
            <!--            <el-button type="primary" @click="onCheckWorkExperienceFrom">测试验证</el-button>-->
          </div>
        </el-card>
      </div>

      <!--位符-->
      <div style="height: 50px"></div>

      <!--所获认证-->
      <div style="width: 98%; margin:0 auto; ">
        <el-card style="border-color: #2763af;">
          <div slot="header">
            <p>
              <em class="workExperience"></em>
              <span class="bsicInfo">所获认证</span>
              <span style="float: right; padding: 3px 0; margin-right: 30px;cursor: pointer;" class="bsicInfo"
                    @click="onAddAuthenticationFrom">添加所获认证</span>
              <em class="addToButton" style="float: right; padding: 3px 0; margin-right: 10px;cursor: pointer;"
                 @click="onAddAuthenticationFrom"></em>
            </p>

          </div>
          <div>
            <el-form label-position="top" ref="authenticationFrom" :model="authenticationFrom">

              <div v-for="(itemWork,index) in authenticationFrom.authentication_list">

                <!--删除按钮-->
                <div style="cursor: pointer;display: inline-block;"
                     v-show="itemWork.row1 !== 1"
                     @click="deleteAuthenticationFrom(itemWork)"><em class="el-icon-remove"
                                                                    style="color : red;">删除本项</em>
                </div>

                <el-row>
                  <!-- 品牌-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.brandCode')"
                                  :prop="'authentication_list.' + index + '.brandCode'"
                                  :rules="[{ required: true, message: '品牌不能为空',trigger: 'change'}]"
                    >
                      <el-select v-model="itemWork.brandCode"
                                 clearable>
                        <el-option v-for="(item,index) in totalBrand"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>

                    </el-form-item>
                  </el-col>

                  <!-- 选择证书-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.selectCertificateName')"
                                  :prop="'authentication_list.' + index + '.certificate'"
                                  :rules="[{ required: true, message: '证书不能为空',trigger: 'change'}]"
                    >
                      <el-select v-model="itemWork.certificate"
                                 clearable>
                        <el-option v-for="(item,index) in certificate"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <!-- 证书等级-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.certificateNameLevel')"
                                  :prop="'authentication_list.' + index + '.grade'"
                                  :rules="[{ required: true, message: '证书等级不能为空',trigger: 'change'}]"
                    >
                      <el-select v-model="itemWork.grade"
                                 clearable>
                        <el-option v-for="(item,index) in certificateGrade"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>

                  <!--获得年份-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.yearGained')"
                                  :prop="'authentication_list.' + index + '.yearGained'"
                                  :rules="[{ required: true, message: '获得年份不能为空',trigger: 'change'}]"
                    >
                      <el-date-picker v-model="itemWork.yearGained"
                                      type="year"
                                      :editable="false"
                                      value-format="yyyy"
                                      :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <div style="height: 15px"></div>
                <el-row>
                  <el-col :span="12">
                    <el-form-item prop="isUpload">
                      <!--                      <upload-file-->
                      <!--                              :ref="uploadFile0"-->
                      <!--                              :auto-upload="true"-->
                      <!--                              :data="itemWork"-->
                      <!--                              v-bind:resumeSubmitFile="resumeSubmitFile(itemWork)"-->
                      <!--                              v-bind:fileList="itemWork.archive"-->
                      <!--                              v-bind:beforeRemove="uploadBeforeRemove"-->
                      <!--                              v-bind:uploadSuccess="submitUploadSuccess"></upload-file>-->
                      <el-upload
                              class="upload-demo"
                              accept=".jpg,.png"
                              :action="updateURL"
                              :on-preview="handlePreview"
                              multiple
                              :on-success="submitUploadSuccess"
                              :limit="1"
                              :before-upload="beforeAvatarUpload"
                              :before-remove="uploadBeforeRemove"
                              :on-exceed="handleExceed"
                              :file-list="itemWork.fileList">
                        <el-button size="small" type="primary" @click="resumeSubmitFile(itemWork,index)">点击上传
                        </el-button>
                        <div slot="tip" class="el-upload__tip">上传文件(不超过4M，上传格式为jpg/png文件)</div>
                      </el-upload>
                    </el-form-item>
                    <!--                    <div style="text-align: left;font-size: 12px;color: darkgray;">-->
                    <!--                      {{'上传文件(不超过4M，上传格式为jpg/png文件)'}}-->
                    <!--                    </div>-->
                    <!--                    <el-button v-if="itemWork.archive !== '' || itemWork.archive"-->
                    <!--                               size="mini"-->
                    <!--                               @click="downloadFile"-->
                    <!--                               type="text">{{itemWork.archive}}-->
                    <!--                    <el-button v-if="itemWork.archive !== '' || itemWork.archive"-->
                    <!--                               size="mini"-->
                    <!--                               @click="viewImage(itemWork)"-->
                    <!--                               type="text">{{itemWork.certificateName}}-->
                    <!--                    </el-button>-->
                  </el-col>

                </el-row>
                <!--位符-->
                <div style="height: 50px"></div>
              </div>
            </el-form>
            <!--            <el-button type="primary" @click="onCheckAuthentication">测试验证</el-button>-->
          </div>
        </el-card>
      </div>

      <!--占位符-->
      <div style="height: 50px"></div>
      <!--教育背景-->
      <div style="width: 98%; margin:0 auto; ">
        <el-card style="border-color: #2763af;">
          <div slot="header">
            <p>
              <em class="educationalBackground"></em>
              <span class="bsicInfo">教育背景</span>
              <span style="float: right; padding: 3px 0; margin-right: 30px;cursor: pointer;" class="bsicInfo"
                    @click="onAddEducationalBackgroundFrom">添加教育背景</span>
              <em class="addToButton" style="float: right; padding: 3px 0; margin-right: 10px;cursor: pointer;"
                 @click="onAddEducationalBackgroundFrom"></em>
            </p>

          </div>
          <div>
            <el-form label-position="top" ref="educationalBackgroundFrom" :model="educationalBackgroundFrom">
              <div v-for="(itemWork,index) in educationalBackgroundFrom.educationalBackground_list">

                <!--删除按钮-->
                <div style="cursor: pointer;display: inline-block;"
                     v-show="itemWork.row1 !== 1"
                     @click="deleteEducationalBackgroundFrom(itemWork)"><em class="el-icon-remove"
                                                                           style="color : red;">删除本项</em>
                </div>

                <el-row>
                  <!--开始时间-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.startDate')"
                                  :prop="'educationalBackground_list.' + index + '.startDate'"
                                  :rules="[{ required: true, message: '开始时间不能为空',trigger: 'change'}]"
                    >
                      <el-date-picker v-model="itemWork.startDate"
                                      type="year"
                                      :editable="false"
                                      value-format="yyyy"
                                      :picker-options="pickerOptions">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>

                  <!--结束时间-->
                  <el-col :span="6">
<!--                    <el-form-item :label="$t('talentpool.endDate')"-->
<!--                                  :prop="'educationalBackground_list.' + index + '.endDate'"-->
<!--                                  :rules="[{ required: true, message: '结束时间不能为空',trigger: 'change'}]"-->
<!--                    >-->
                      <el-form-item :label="$t('talentpool.endDate')"
                                    :prop="'educationalBackground_list.' + index + '.endDate'"
                                    :rules="[{ required: true, message: '结束时间不能为空',trigger: 'change'}]"
                      >
                      <el-date-picker v-model="itemWork.endDate"
                                      type="year"
                                      :editable="false"
                                      value-format="yyyy">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>

                  <!--学校-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.school')"
                                  :prop="'educationalBackground_list.' + index + '.school'"
                                  :rules="[{ required: true, message: '学校不能为空',trigger: 'change'}]"
                    >
                      <el-input v-model.trim="itemWork.school" maxlength="200"></el-input>
                    </el-form-item>
                  </el-col>

                  <!--学历-->
                  <el-col :span="6">
                    <el-form-item :label="$t('talentpool.educationName')"
                                  :prop="'educationalBackground_list.' + index + '.education'"
                                  :rules="[{ required: true, message: '学历不能为空',trigger: 'change'}]"
                    >
                      <el-select v-model="itemWork.education"
                                 clearable>
                        <el-option v-for="(item,index) in educationCode"
                                   :key="index"
                                   :label="item.name"
                                   :value="item.code">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!--专业-->
                <el-row>
                  <el-col :span="6">
<!--                    <el-form-item :label="$t('talentpool.major')"-->
<!--                                  :prop="'educationalBackground_list.' + index + '.major'"-->
<!--                                  :rules="[{ required: true, message: '专业不能为空',trigger: 'change'}]">-->
                    <el-form-item :label="$t('talentpool.major')">
                      <el-input v-model.trim="itemWork.major" placeholder="关键管理岗必填" maxlength="200"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
                <!--位符-->
                <div style="height: 50px"></div>
              </div>
            </el-form>
            <!--            <el-button type="primary" @click="onCheckEducationalBackgroundFrom">测试验证</el-button>-->
          </div>
        </el-card>
      </div>

      <!--占位符-->
      <div style="height: 50px"></div>
      <!--个人技能-->
      <div style="width: 98%; margin:0 auto; ">
        <el-card style="border-color: #2763af;">
          <div slot="header">
            <p>
              <em class="personalSkills"></em>
              <span class="bsicInfo">个人技能</span>
            </p>

          </div>
          <div>
            <el-form label-position="top">
              <!--语言技能-->
              <el-row>
                <el-col :span="24">
                  <el-form-item :label="$t('talentpool.languageSkills')">
                  </el-form-item>
                </el-col>
                <el-input v-model="dataForm.languageSkills" type="textarea" :maxlength="500"
                          show-word-limit :rows="4"
                          placeholder="请输语言技能（限输入500字)"></el-input>
              </el-row>
              <!--占位符-->
              <div style="height: 50px"></div>

              <!--驾驶技能-->
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('talentpool.drivingSkills')">
                  </el-form-item>
                </el-col>
                <el-input v-model="dataForm.drivingSkills" type="textarea" :maxlength="500"
                          show-word-limit :rows="4"
                          placeholder="请输入驾驶技能（限输入500字)"></el-input>
              </el-row>
              <!--占位符-->
              <div style="height: 50px"></div>

              <!--计算机技能-->
              <el-row>
                <el-col :span="24">
                  <el-form-item :label="$t('talentpool.computerSkills')">
                  </el-form-item>
                </el-col>
                <el-input v-model="dataForm.computerSkills" type="textarea" :maxlength="500"
                          show-word-limit :rows="4"
                          placeholder="请输入计算机技能（限输入500字)"></el-input>
              </el-row>
              <!--占位符-->
              <div style="height: 50px"></div>

              <!--其他技能-->
              <el-row>
                <el-col :span="6">
                  <el-form-item :label="$t('talentpool.otherSkills')">
                  </el-form-item>
                </el-col>
                <el-input v-model="dataForm.otherSkills" type="textarea" :maxlength="500"
                          show-word-limit :rows="4"
                          placeholder="请输入其他技能（限输入500字)"></el-input>
              </el-row>
              <!--占位符-->
              <div style="height: 50px"></div>

              <!--							<el-row class="row-mar-l">-->
              <!--								<el-button type="primary">保存个人技能</el-button>-->
              <!--							</el-row>-->
            </el-form>
          </div>
        </el-card>
      </div>

      <!--占位符-->
      <div style="height: 50px"></div>

      <!--按钮-->
      <div align="center" class="divcheckbox">
        <el-checkbox v-model="countDownForm.privacyChecked" @change="resumePolicyChange">

        </el-checkbox>
        <el-link :underline="false" @click="resumePolicyClick" style="margin-right: 30px;">同意简历政策</el-link>
        <el-button type="primary" @click="onSubmitfornext('1')" v-if="isAc === '0'">保存并下一步</el-button>

        <el-button type="primary" @click="onSubmitfornext('2')">保存</el-button>
        <el-button @click="cancel" v-if="isAc === '0'">取消</el-button>
        <el-button @click="cancelSendShowResume" v-if="isAc !== '0'">取消</el-button>
      </div>

      <!--占位符-->
      <div style="height: 50px"></div>
      <!-- 弹窗, 修改头像 -->
      <modifyImg v-if="modifyImgVisible"
                 @refreshImg="refreshImg"
                 ref="modifyImg"></modifyImg>

      <!-- 弹窗, 简历协议 -->
      <ResumePolicy v-if="countDownForm.agreementVisible"
                    @func="resumePolicyEmit"
                    ref="resumePolicy"></ResumePolicy>

      <!-- 弹窗, 简历协议 确定按钮 -->
      <ResumePolicyOK v-if="countDownForm.agreementVisible"
                      @func="resumePolicyEmit"
                      ref="resumePolicyOK"></ResumePolicyOK>


      <!--点击附件打开图片预览 -->
      <el-dialog
              :visible.sync="isShowImag"
              top="5vh"
              width="95%"
              :close-on-click-modal="false">
        <img
                :src="srcList"
                style="width: 100%;height: auto;display: block; margin: 0 auto;" alt=""
                @contextmenu.prevent
        />
      </el-dialog>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import ClassTree from '../comm/class-tree/index'
  import ModifyImg from "../../../protal/modifyImg";
  import UploadFile from '../comm/upload-file/index'
  import ResumePolicy from './resumePolicy'
  import ResumePolicyOK from './resumePolicyOK'

  export default {
// import引入的组件需要注入到对象中才能使用
    components: {
      'class-tree': ClassTree,
      ModifyImg,
      'upload-file': UploadFile,
      ResumePolicy: ResumePolicy,
      ResumePolicyOK: ResumePolicyOK
    },
    props: [],
    data() {
      let _this = this
      return {

        query:{
          userId: this.$route.query.userId,
          jobName: this.$route.query.jobName,
          orgName: this.$route.query.orgName,
          recruitmentId:this.$route.query.recruitmentId,
          isAssessmentListNew:this.$route.query.isAssessmentListNew,
        },

        jobName: '',
        orgName: '',

        // isAc: this.$route.query.isAc,  // 是否是ac简历  0：是  1：不是
        isAc: '0',  // 是否是ac简历  0：是  1：不是
        userId: '',
        // userId: _this.$router.query.userId,

        updateURL: window.SITE_CONFIG['apiBaseURL'] + '/sys/config/appImgUpload',
        authenticUpladIndex: 0,
        authenticUplad: {},
        dataForm: {
          name: '',
          gender: '',
          birthday: '',
          idType: '',
          idNo: '',
          education: '',
          nativePlaceArr: [],
          nationality: '',
          registeredResidenceArr: [],
          nativePlaceName: '',
          registeredResidenceName: '',
          liveArr: [],
          live: '',
          liveName: '',
          headurl: require('@/assets/img/default-image.png'),
          tel: '',
          mail: '',
          wechatNo: '',
          personalEvaluation: '',
          firstWorkYear: '',
          orgName: '',
          majorPositions: '',
          bmwJoinDate: '',
          networkJoinDate: '',
          workYears: '',
          bmwAgeYear: '',
          brandCode: '',
          brandCodeName: '',
          company: '',
          job: '',
          startDate: '',
          endDate: '',
          totalBrand: '',
          selectCertificateName: '',
          certificateGrade: '',
          yearGained: '',
          educationStartDate: '',
          educationEndDate: '',
          languageSkills: '',
          drivingSkills: '',
          computerSkills: '',
          otherSkills: '',

        },
        // 简历政策相关
        countDownForm: {
          agreementVisible: true,
          privacyChecked: false, // 勾选状态
          count: "", // 初始化次数
          timer: null,
          s: '',
          determine: '确定',
        },
        resumePolicydialogVisible: false,

        // 工作经历
        workExperienceFrom: {
          workExperience_list: [
            {
              row1: 1,
              industryType: 10,
              brandCode: '',
              brandCodeName: '',
              company: '',
              job: '',
              startDate: '',
              endDate: '',
              jobDescription: '',
              itemNow: 0,
            }
          ]
        },

        // 获得认证
        authenticationFrom: {
          authentication_list: [
            {
              row1: 1,
              totalBrand: '',
              selectCertificateName: '',
              grade: '',
              certificateGrade: '',
              yearGained: '',
              // 上传的文件
              fileList: [],
            }
          ]
        },
        // 教育背景
        educationalBackgroundFrom: {
          educationalBackground_list: [
            {
              row1: 1,
              educationStartDate: '',
              educationEndDate: '',
              school: '',
              educationName: '',
              major: '',
            }
          ]
        },
        // 临时存储 工作经历
        workExperienceFromTeam: {
          workExperience_listTeam: []
        },
        // 临时存储 获得认证
        authenticationFromTeam: {
          authentication_listTeam: []
        },
        // 临时存储 教育背景
        educationalBackgroundFromTeam: {
          educationalBackground_listTeam: []
        },
        dataList: {},
        // 性别
        sexCode: _this.enums['sex'],
        // 证件类型
        idType: _this.enums['idType'],
        // 最高学历
        educationCode: _this.enums['educationCode'],
        // 国籍
        nationality: _this.enums['nationality'],
        // 民族
        nation: _this.enums['nation'],
        // 品牌
        workBrand: _this.enums['workBrand'],
        // 所选行业
        industry: _this.enums['industry'],
        // 认证品牌
        totalBrand: _this.enums['totalBrand'],
        // 选择证书
        certificate: _this.enums['certificate'],
        // 证书等级
        certificateGrade: _this.enums['certificateGrade'],
        // 预览图片的地址
        srcList: "",
        isShowImag: false,

        // 主页面城市树
        queryCityTreeUrl: '/rm/courseclassroomrela/queryregiontree',
        citydefaultProps: {
          children: 'childrenRegionList',
          label: 'regionNameCn'
        },
        // cityclassInfo(listName) {
        //   if (listName === 'city') {
        //     this.dataForm.registeredResidenceName = ''
        //   }
        // },
        // clearClassTreeInfo(clearName) {
        //   if (listName === 'city') {
        //     this.dataForm.registeredResidenceName = ''
        //   }
        // },
        // cityclassInfo2(listName) {
        //   console.log(this.dataForm)
        //   if (listName === 'city' && this.dataForm !== undefined) {
        //     this.dataForm.registeredResidenceName = ''
        //   }
        // },
        // cityclassInfo3(listName) {
        //   console.log(this.dataForm)
        //   if (listName === 'city' && this.dataForm !== undefined) {
        //     this.dataForm.nativePlaceName = ''
        //   }
        // },


        // 基本信息验证
        dataListRules: {
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            {min: 0, max: 50, message: '长度必须小于 50 个字符', trigger: 'blur'}
          ],
          gender: [
            {required: true, message: '请选择性别', trigger: 'change'}
          ],
          birthday: [
            {required: true, message: '请选择日期', trigger: 'change'}
          ],
          idType: [
            {required: true, message: '请选择证件类型', trigger: 'change'}
          ],

          // idNo: [
          //   {required: true, message: '请输入证件编号', trigger: 'blur'},
          //   {min: 0, max: 50, message: '长度必须小于 50 个字符', trigger: 'blur'}
          // ],
          education: [
            {required: true, message: '请选择最高学历', trigger: 'change'}
          ],
          liveName: [
            {required: true, message: '目前居住省份/城市', trigger: 'change'}
          ],
          // tel: [
          //   {required: true, message: '请输入手机号', trigger: 'blur'},
          //   {min: 0, max: 11, message: '长度必须小于 11 个字符', trigger: 'blur'}
          // ],
          // mail: [
          //   {required: true, message: '请输入邮箱', trigger: 'blur'},
          //   {min: 0, max: 50, message: '长度必须小于 50 个字符', trigger: 'blur'}
          // ],
          firstWorkYear: [
            {required: true, message: '请选择日期', trigger: 'blur'}
          ],
        },


        workExperienceFromRules: {
          brandCode: [
            {required: true, message: '请选择最高学历', trigger: 'change'}
          ],
        },

        // 是否显示修改头像
        modifyImgVisible: false,


        // 用于时间限制的临时赋值
        onStartDate: '',
        onEndDate: '',

        itemNow: 0,
        // 开始时间验证器
        pickerOptionsStart: {},
        pickerOptionsEnd: {},

        pickerOptionsStartAll: [],
        pickerOptionsEndAll: [],

        // 教育背景的时间限制
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
		needId: null,
      }
    },
// 监听属性 类似于data概念
    computed: {},
// 监控data中的数据变化
    watch: {},
// 生命周期 - 创建完成（可以访问当前this实例）
    created() {
      console.log('this.$route.query')
      console.log(this.$route.query)
      this.jobName = this.$route.query.jobName
      this.orgName = this.$route.query.orgName
      this.isAc = this.$route.query.isAc
      this.userId = this.$route.query.userId

    },
// 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getInfo()

    },
    beforeCreate() {
      console.log('beforeCreate')
    }, // 生命周期 - 创建之前
    beforeMount() {
      console.log('beforeMount')
    }, // 生命周期 - 挂载之前
    beforeUpdate() {
      console.log('beforeUpdate')
    }, // 生命周期 - 更新之前
    updated() {
      console.log('updated')
    }, // 生命周期 - 更新之后
    beforeDestroy() {
      console.log('beforeDestroy')
    }, // 生命周期 - 销毁之前
    destroyed() {
      console.log('destroyed')
    }, // 生命周期 - 销毁完成
    activated() {
      console.log('activated')
    },

// 方法集合
    methods: {
      cityclassInfo(listName) {
        if (listName === 'city') {
          this.dataForm.liveArr = []
          this.dataForm.liveName = ''
          this.dataForm.live = ''
        }
      },
      cityclassInfo2(listName) {
        console.log(this.dataForm)
        if (listName === 'city' && this.dataForm !== undefined) {
          this.dataForm['registeredResidence'] = ''
          this.dataForm.registeredResidenceArr = []
          this.dataForm.registeredResidenceName = ''
        }
      },
      cityclassInfo3(listName) {
        console.log(this.dataForm)
        if (listName === 'city' && this.dataForm !== undefined) {
          this.dataForm.nativePlaceName = ''
          this.dataForm.nativePlaceArr = []
          this.dataForm['nativePlace'] = ''
        }
      },
      changeStart(itemWork, index) {
        console.log('chengeStart')
        console.log(itemWork, index)
        console.log(this.pickerOptionsStartAll)

        this.pickerOptionsStartAll[itemWork.itemNow].pickerOptionsStart = {
          disabledDate: (time) => {
            for (var i = 0; i < this.workExperienceFrom.workExperience_list.length; i++) {
              if (this.workExperienceFrom.workExperience_list[i].itemNow === itemWork.itemNow) {
                // console.log('changeStart 赋值后' + itemWork.itemNow)
                let endDates = new Date(itemWork.endDate)
                endDates.setMonth(endDates.getMonth() - 1);
                return time.getTime() > endDates
              }
            }
          }
        }
        // this.pickerOptionsStartAll[itemWork.itemNow].pickerOptionsStart = Object.assign({}, this.pickerOptionsStartAll[itemWork.itemNow].pickerOptionsStart, {
        //   disabledDate: (time) => {
        //     // 删除后再次赋值
        //     console.log('changeStart 赋值后' + itemWork.itemNow)
        //     let endDates = new Date(itemWork.endDate)
        //     endDates.setMonth(endDates.getMonth() - 1);
        //     return time.getTime() > endDates
        //   }
        // })
      },
      changeEnd(itemWork, index) {
        console.log('chengeEnd')
        console.log(itemWork, index)

        this.pickerOptionsEndAll[itemWork.itemNow].pickerOptionsEnd = {
          disabledDate: (time) => {
            // console.log(this.workExperienceFrom.workExperience_list)
            for (var i = 0; i < this.workExperienceFrom.workExperience_list.length; i++) {
              if (this.workExperienceFrom.workExperience_list[i].itemNow === itemWork.itemNow) {
                // console.log('changeEnd 赋值后' + itemWork.itemNow)
                let startDates = new Date(itemWork.startDate)
                startDates.setMonth(startDates.getMonth() + 1);
                return time.getTime() < startDates
              }
            }
          }
        }

        // this.pickerOptionsEndAll[itemWork.itemNow].pickerOptionsEnd = Object.assign({}, this.pickerOptionsEndAll[itemWork.itemNow].pickerOptionsEnd, {
        //   disabledDate: (time) => {
        //     console.log('changeEnd 赋值后' + itemWork.itemNow)
        //     let startDates = new Date(itemWork.startDate)
        //     startDates.setMonth(startDates.getMonth() + 1);
        //     return time.getTime() < startDates
        //   }
        // })
      },

      // 工作经历-- 工作描述与职责 -- 验证
      jobDescriptionChange(index){
        console.log('jobDescriptionChange')
        console.log(index)
      },

      pickerGetDateStart(itemNow) {
        this.$nextTick(() => {
          if (this.pickerOptionsStartAll[itemNow] !== undefined) {
            return this.pickerOptionsStartAll[itemNow].pickerOptionsStart
          }
        });
      },
      pickerGetDateEnd(itemNow) {
        this.$nextTick(() => {
          if (this.pickerOptionsEndAll[itemNow] !== undefined) {
            return this.pickerOptionsEndAll[itemNow].pickerOptionsEnd
          }
        });
      },

      headModifyShow() {
        console.log('headModifyShow')
      },
      addRow() {
        this.workExperienceFrom.workExperience_list.push({
          fieldName: "",
          fieldSort: "",
          fieldDesc: "",
          fieldTime: ""
        });
      },
      // 切换 工作经历时候触发。 暂时注释
      checkBrandCode(itemWork, index) {
        console.log('品牌切换。')
        console.log(itemWork)
        console.log(itemWork.industryType)

        // this.$set(this.workExperienceFrom.workExperience_list[index],'brandCode','')
        // this.$set(this.workExperienceFrom.workExperience_list[index],'industry','')
        // this.$set(this.workExperienceFrom.workExperience_list[index],'otherBrandCodeName','')

        if (itemWork.industryType === '10') {
          console.log('checkBrandCode 10 90')
          // this.$set(this.workExperienceFrom.workExperience_list[index],'brandCode','')

          this.$set(this.workExperienceFrom.workExperience_list[index],'otherBrandCodeName','')
        }else {
          console.log('checkBrandCode')
          this.$set(this.workExperienceFrom.workExperience_list[index],'industry','')
          this.$set(this.workExperienceFrom.workExperience_list[index],'brandCode','')
        }
      },
      // 切换 工作经历时候触发。 暂时注释
      checkBrandCode2(itemWork, index) {
        console.log('品牌切换。')
        console.log(itemWork)
        console.log(itemWork.industryType)

        // this.$set(this.workExperienceFrom.workExperience_list[index],'brandCode','')
        // this.$set(this.workExperienceFrom.workExperience_list[index],'industry','')
        // this.$set(this.workExperienceFrom.workExperience_list[index],'otherBrandCodeName','')

        if (itemWork.industryType === '10') {
          console.log('checkBrandCode 10 90')
          // this.$set(this.workExperienceFrom.workExperience_list[index],'brandCode','')

          this.$set(this.workExperienceFrom.workExperience_list[index],'otherBrandCodeName','')
        }else {
          console.log('checkBrandCode')
          this.$set(this.workExperienceFrom.workExperience_list[index],'industry','')
          this.$set(this.workExperienceFrom.workExperience_list[index],'brandCode','')
        }
      },
      // 删除属性列
      removeRow(index) {
        this.workExperienceFrom.workExperience_list.splice(index, 1);
      },
      // 提交
      submit() {
        this.$refs['workExperienceFrom'].validate(valid => {
          console.log(this.workExperienceFrom);
          if (valid) {
            alert("submit!");
          } else {
            return false;
          }
        });
      },

      // 工作经历 所属行业 切换选择
      checkIndustryType: function (index) {

        let industryType = this.workExperienceFrom.workExperience_list[index].industryType;
        // 10: 汽车    20：其他
        if (industryType === '10') {
          // 选择<汽车>时候。 品牌显示 所属行业隐藏
          // this.workExperienceFrom.workExperience_list[index].industry = ''

        } else if (industryType === '20') {
          console.log(this.workExperienceFrom.workExperience_list[index])
          // // 选择<其他>时候。 品牌隐藏 所属行业显示
          // // this.workExperienceFrom.workExperience_list[index].brandCode = ''
          // this.workExperienceFrom.workExperience_list[index].industry = ''
          // delete this.workExperienceFrom.workExperience_list[index].brandCode
          console.log(this.workExperienceFrom.workExperience_list[index])
        }
      },

      // 基本信息 验证
      onCheckInfoFrom() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            console.log(' submit!!');
            return true;
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      // 工作经历 测试小表单验证
      onCheckWorkExperienceFrom: function () {
        this.$refs['workExperienceFrom'].validate((valid) => {
          if (valid) {
            console.log(' submit!!');
            callback(true);
          } else {
            console.log('error submit!!');
            callback(false);
          }
        })
      },
      // 所获认证 测试小表单验证
      onCheckAuthentication() {
        this.$refs['authenticationFrom'].validate((valid) => {
          if (valid) {
            console.log(' submit!!');
            return true;
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      // 教育背景 测试小表单验证
      onCheckEducationalBackgroundFrom() {
        this.$refs['educationalBackgroundFrom'].validate((valid) => {
          if (valid) {
            console.log(' submit!!');
            return true;
          } else {
            console.log('error submit!!');
            return false;
          }
        })
      },
      // 获取信息
      getInfo() {
        this.$nextTick(() => {
          console.log('nextTick')
        })
        // this.$refs['dataListRules'].resetFields();
        if (this.$route.query.userId) {
          this.$request
            .get('/talent/talentpool/queryResumeInfoMT', {
              userId: this.$route.query.userId
            })
            .then((res, total, code, data) => {
              this.dataForm = data.data
              // 单独给省/市 赋值
              let nativePlace = data.data.nativePlace
              this.dataForm.nativePlaceArr = [nativePlace]

              let registeredResidence = data.data.registeredResidence
              this.dataForm.registeredResidenceArr = [registeredResidence]

              let liveArr = data.data.live
              this.dataForm.liveArr = [liveArr]

              // 证件编码修改
              this.dataForm.idNoT = this.idcardFormatter(data.data.idNo)
              // 手机号加密
              this.dataForm.telT = this.mobileFormatter(data.data.tel)
              // 邮箱加密
              this.dataForm.mailT = this.emailFormatter(data.data.mail)

              // 工作经历
              this.workExperienceFrom.workExperience_list = data.data.resumeWorkDtoList
              // 工作经历中结束时间为空时 赋值为空
              for (let i = 0; i <data.data.resumeWorkDtoList.length; i++) {
                if(data.data.resumeWorkDtoList[i].endDate === '至今' || data.data.resumeWorkDtoList[i].endDate === ''){
                  this.workExperienceFrom.workExperience_list[i].endDate = ''
                }
              }


              //所获认证
              this.authenticationFrom.authentication_list = data.data.resumeAuthenticationDtoList



              // 获得认证中的附件单独处理
              for (var i = 0; i < this.authenticationFrom.authentication_list.length; i++) {
                if (this.authenticationFrom.authentication_list[i].archive !== "") {
                  let tmpArr = [{
                    name: '附件',
                    url: this.authenticationFrom.authentication_list[i].archive
                  }]
                  this.$set(this.authenticationFrom.authentication_list[i], 'fileList', tmpArr)
                }
              }


              console.log(this.authenticationFrom.authentication_list)
              // 教育背景
              this.educationalBackgroundFrom.educationalBackground_list = data.data.resumeEducationDtoList

              console.log('this.authenticationFrom')
              console.log(this.authenticationFrom)

              // 判断是否弹出简历政策  id 是否为空
              // 简历政策弹出框
              console.log('data.id')
              console.log(data.data.id)
              if (data.data.id === '' || data.data.id === undefined || data.data.id === null) {
                this.countDownForm.privacyChecked = false
                this.resumePolicyClick()
              } else {
                // 简历政策勾选框选中
                this.countDownForm.privacyChecked = true
              }

            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          this.dataForm = {}
        }
      },
      // 证件编号加密 身份证只加密出生日期，护照号保留第一位和后三位
      idcardFormatter(rowIdcard) {
        if (rowIdcard !== null && rowIdcard.length === 10) {
          let a = rowIdcard.substring(0, 1)
          let b = rowIdcard.substr(rowIdcard.length - 3)
          let encryption = ''
          for (let i = 0; i < rowIdcard.length - 4; i++) {
            encryption += '⁎'
          }
          return a + encryption + b
        } else if (rowIdcard !== null && rowIdcard.length >= 11) {
          let a = rowIdcard.substring(0, 6)
          let b = rowIdcard.substr(rowIdcard.length - 4)
          return a + '⁎⁎⁎⁎⁎⁎⁎⁎' + b
        } else {
          return rowIdcard
        }
      },
      // 手机号加密 只显示后四位
      mobileFormatter(rowMobile) {
        if (rowMobile && rowMobile !== '') {
          let encryption = ''
          for (let i = 0; i < rowMobile.length - 4; i++) {
            encryption += '⁎'
          }
          let mobile = encryption + rowMobile.substr(rowMobile.length - 4)
          return mobile
        } else {
          return rowMobile
        }
      },
      // 邮箱加密 @之前如果超过2位，显示后两位，如果不超过两位，全部隐藏
      emailFormatter(rowEmail) {
        if (rowEmail && rowEmail !== '') {
          let index = rowEmail.split('@')
          let partOne = index[0]
          let partTwo = index[1]
          let encryption = ''
          if (partOne.length <= 2) {
            for (let i = 0; i < partOne.length; i++) {
              encryption += '⁎'
            }
            return encryption + '@' + partTwo
          } else {
            for (let i = 0; i < partOne.length - 2; i++) {
              encryption += '⁎'
            }
            let email = partOne.substring(0, 2) + encryption
            return email + '@' + partTwo
          }
        } else {
          return rowEmail
        }
      },

      // 保存并下一步 页面跳转
      onSubmitfornext: function (isNext) {
        let _this = this
        console.log('保存并下一步验证')
        let checkMsg = ''
        let checkinfo = false

        // 验证 简历政策是否勾选
        if (this.countDownForm.privacyChecked === false) {
          checkinfo = true
          checkMsg = checkMsg + "请先同意简历政策 "
        }

        // 验证 基本信息
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            console.log('基本信息 submit!!');
          } else {
            console.log('基本信息 submit!!');
            checkinfo = true
            checkMsg = checkMsg + "基本信息有未填项 "
          }
        })

        // 验证 工作经历
        this.$refs['workExperienceFrom'].validate((valid) => {
          if (valid) {
            console.log('工作经历 submit!!');
            for (var i = 0; i < this.workExperienceFrom.workExperience_list.length; i++) {
              let startDateLet = this.workExperienceFrom.workExperience_list[i].startDate
              let endDateLet = this.workExperienceFrom.workExperience_list[i].endDate
              if(endDateLet !== null){
                var sDate = new Date(startDateLet)
                var eDate = new Date(endDateLet);
                if (sDate > eDate) {
                  checkinfo = true
                  checkMsg = checkMsg + "工作经历中第" + (i + 1) + "条开始时间大于结束时间 "
                }
              }

            }
          } else {

            checkinfo = true
            checkMsg = checkMsg + "工作经历有未填项 "
          }
        })

        // 验证 所获认证
        this.$refs['authenticationFrom'].validate((valid) => {
          if (valid) {
            console.log('所获认证 submit!!');
            return true;
          } else {
            console.log('所获认证 submit!!');
            checkinfo = true
            checkMsg = checkMsg + "所获认证有未填项 "
          }
        })

        // 验证 所获认证对应附件为必填
        let checkFilelist = false
        for(var i=0; i<this.authenticationFrom.authentication_list.length; i++){
          if(this.authenticationFrom.authentication_list[i].archive === ''){
            checkFilelist = true
          }
        }
        if(checkFilelist){
          checkinfo = true
          checkMsg = checkMsg + "所获认证对应附件有未上传项 "
        }


        // 验证 教育背景
        this.$refs['educationalBackgroundFrom'].validate((valid) => {
          if (valid) {
            console.log('教育背景 submit!!');
            for (var i = 0; i < this.educationalBackgroundFrom.educationalBackground_list.length; i++) {
              let startDateLet = this.educationalBackgroundFrom.educationalBackground_list[i].startDate
              let endDateLet = this.educationalBackgroundFrom.educationalBackground_list[i].endDate
              var sDate = new Date(startDateLet)
              var eDate = new Date(endDateLet);
              if (sDate > eDate) {
                checkinfo = true
                checkMsg = checkMsg + "教育背景中第" + (i + 1) + "条开始时间大于结束时间 "
              }
            }
          } else {
            console.log('教育背景 submit!!');
            checkinfo = true
            checkMsg = checkMsg + "教育背景有未填项 "
          }
        })


        if (checkinfo) {
          this.$message.error(checkMsg + "不能保存")
        } else {
          console.log('保存')
          console.log(this.$refs.uploadFile)

          // for(var i=0; i<this.authenticationFrom.authentication_list.length; i++ ){
          //   let gv='uploadFile'+i;
          //   let uploadFiles = this.$refs[gv]
          //   let tupload = this.$refs.uploadFile0
          //   this.$refs.uploadFile0.submit()
          //   tupload.submit()
          //   // uploadFiles.submit()
          //
          // }


          // 基本信息验证
          this.saveResumeInfo()


          // 保存并下一步
          if (this.isAc === '0' && isNext === '1') {
            this.$emit('onShowModer', 'showResumeEditWork')
          }
          // 保存处理
          if (this.isAc === '0' && isNext === '2') {
            this.tabRemove()
            this.barkInfo()
          }
        // 普通简历编辑 跳转到简历查看
          if (this.isAc === '1') {
            this.sendShowResume()
          }


        }
      },
      // 基本信息保存
      saveResumeInfo() {
		  var _that = this;
        // 如果民族为空 民族中文也为空
        if (this.dataForm.nation === null) {
          this.dataForm.nation = ''
          this.dataForm.nationName = ''
        }
        // 如果国籍为空 国籍中文也为空
        if (this.dataForm.nationality === null) {
          this.dataForm.nationality = ''
          this.dataForm.nationalityName = ''
        }
        // 如果籍贯为空 籍贯中文也为空
        if (this.dataForm.nativePlace === null) {
          this.dataForm.nativePlace = ''
          this.dataForm.nativePlaceName = ''
        }
        // 如果目前居住省份/城市为空 目前居住省份/城市中文也为空
        if (this.dataForm.live === null) {
          this.dataForm.live = ''
          this.dataForm.nationName = ''
        }


        this.$request
          .post('/talent/talentresumemain/save', this.dataForm)
          .then((res, total, code, data) => {
            console.log('talent/talentresumemain/save')
            console.log(data)
			_that.needId = data.data.id;
            if (data.code !== 1) {
              this.$message({
                message: this.$t(data.msg),
                type: 'error',
                duration: 2000
              })
              return false
            } else {
				//工作经历保存
			  _that.saveWorkInfo(_that)
			  // 所获认证
			  _that.saveAuthentication(_that)
			  // 教育背景
			  _that.saveEducational(_that)
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
              })
              // if (this.isAc === '1') {
              //   this.sendShowResume()
              // }
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },
      // 工作经历保存
      saveWorkInfo(_this) {
        _this.workExperienceFromTeam.workExperience_listTeam = []
        console.log('saveWorkInfo')
        console.log(_this.workExperienceFrom.workExperience_list)
        for (var i = 0; i < _this.workExperienceFrom.workExperience_list.length; i++) {
          var work = _this.workExperienceFrom.workExperience_list[i];
          if(work.endDate === null || work.endDate === ''){
            work.endDate = '至今'
          }
		  work.resumeMainId = _this.needId;
          _this.$request
            .post('/talent/talentresumemain/saveWork', work)
            .then((res, total, code, data) => {
              console.log(data)
              if (code !== 1) {
                this.$message({
                  message: _this.$t(data.msg),
                  type: 'error',
                  duration: 2000
                })
                return false
              } else {
                if (work.endDate !== '' || work.endDate !== undefined) {
                  data.data.endDate = work.endDate
                }
                _this.workExperienceFromTeam.workExperience_listTeam.push(data.data)
              }
              // if (this.isAc === '1') {
              //   this.sendShowResume()
              // }
            })
            .catch((err) => {
              console.log(err)
            })

        }
        _this.workExperienceFrom.workExperience_list = _this.workExperienceFromTeam.workExperience_listTeam
      },
      // 所获认证保存
      saveAuthentication(_this) {
        _this.authenticationFromTeam.authentication_listTeam = []
        for (var i = 0; i < _this.authenticationFrom.authentication_list.length; i++) {
          var authentication = _this.authenticationFrom.authentication_list[i];
		  authentication.resumeMainId = _this.needId;
          _this.$request
            .post('/talent/talentresumemain/saveAuthentication', authentication)
            .then((res, total, code, data) => {
              console.log(this.data)
              if (data.code !== 1) {
                _this.$message({
                  message: _this.$t(data.msg),
                  type: 'error',
                  duration: 2000
                })
                return false
              } else {
                _this.authenticationFromTeam.authentication_listTeam.push(data.data)
              }
              // if (this.isAc === '1') {
              //   this.sendShowResume()
              // }
            })
            .catch((err) => {
              console.log(err)
            })
        }
        _this.authenticationFrom.authentication_list = _this.authenticationFromTeam.authentication_listTeam
      },
      // 教育背景保存
      saveEducational(_this) {
        _this.educationalBackgroundFromTeam.educationalBackground_listTeam = []
        for (var i = 0; i < _this.educationalBackgroundFrom.educationalBackground_list.length; i++) {
          var educational = _this.educationalBackgroundFrom.educationalBackground_list[i];
		  educational.resumeMainId = _this.needId;
          _this.$request
            .post('/talent/talentresumemain/saveEducation', educational)
            .then((res, total, code, data) => {
              console.log(_this.data)
              if (data.code !== 1) {
                _this.$message({
                  message: this.$t(data.msg),
                  type: 'error',
                  duration: 2000
                })
                return false
              } else {
                _this.educationalBackgroundFromTeam.educationalBackground_listTeam.push(data.data)
              }
              // if (this.isAc === '1') {
              //   this.sendShowResume()
              // }
            })
            .catch((err) => {
              console.log(err)
            })
        }
        _this.educationalBackgroundFrom.educationalBackground_list = _this.educationalBackgroundFromTeam.educationalBackground_listTeam
      },

      // 工作经历删除
      delWorkInfo(work) {
        this.$request
          .post('/talent/talentresumemain/deleteWork', work)
          .then((res, total, code, data) => {
            console.log(this.data)
            if (data.code !== 1) {
              this.$message({
                message: this.$t(data.msg),
                type: 'error',
                duration: 2000
              })
              return false
            } else {
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },

      // 所获认证删除
      delAuthentication(authentication) {
        this.$request
          .post('/talent/talentresumemain/deleteAuthentication', authentication)
          .then((res, total, code, data) => {
            console.log(this.data)
            if (data.code !== 1) {
              this.$message({
                message: this.$t(data.msg),
                type: 'error',
                duration: 2000
              })
              return false
            } else {
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },

      // 教育背景删除
      delEducational(educational) {
        this.$request
          .post('/talent/talentresumemain/deleteEducation', educational)
          .then((res, total, code, data) => {
            console.log(this.data)
            if (data.code !== 1) {
              this.$message({
                message: this.$t(data.msg),
                type: 'error',
                duration: 2000
              })
              return false
            } else {
              this.$message({
                message: this.$t('prompt.success'),
                type: 'success',
                duration: 500,
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },

      // 验证
      checkMobileOrEmail(index) {
        var data = ''
        var type = ''
        if (index === 0) {
          data = this.dataForm.mobile
          var regMobile = /^\d{6,15}$/
          if (!regMobile.test(data)) {
            return false
          }
          type = 'mobile'
        }
        if (index === 1) {
          data = this.dataForm.mail
          var regEmail = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,3})$/
          if (!regEmail.test(data)) {
            return false
          }
          type = 'email'
        }
        var param = {
          mobileOrEmail: data,
          type: type
        }
        // 如果新增
        if (this.jobabled === false) {
          param['userId'] = this.dataForm.userId
        }
        if (this.leaveAndJoinFlag === true) {
          param['userId'] = this.dataForm.userId
        }
        this.$request.get('/sys/commuser/isExist',
          param).then((res, total, code, data) => {
            console.log(res)
        }).catch((err) => {
          console.log(err)
        })
      },

      //简历政策弹出框
      resumePolicyClick() {
        // this.$refs.resumePolicy.init()
        console.log(this.countDownForm.privacyChecked)
        if (this.countDownForm.privacyChecked) {
          this.$refs.resumePolicyOK.init()
        } else {
          this.$refs.resumePolicy.init()
        }
        console.log('简历政策弹出框')
      },
      // 简历政策多选框控制
      resumePolicyChange(value) {
        // // TODO 点击时候要判断是否可以取消多选框
        console.log('resumePolicyChange ')
        console.log(value)

        // 如果是点击状态 false:勾选状态   true:为勾选状态
        if (value) {
          // 勾选状态  弹框
          this.resumePolicyClick()
        } else {
          // 为勾选状态 弹出删除
          this.$request
            .post('/acdc/recruitment/checkUserIsGoingRecrRecordMT', {userIdAes: this.$route.query.userId})
            .then((res, total, code, data) => {
              if (data.code === 1) {
                // 正常  弹出删除提示卡
                console.log(' 弹出删除提示 ')
                this.$confirm(this.$t('prompt.info', {'handle': '删除简历'}), this.$t('prompt.title'), {
                  confirmButtonText: this.$t('confirm'),
                  cancelButtonText: this.$t('cancel')
                }).then(() => {
                  console.log(' 确定 。。。 ')
                  //  TODO 调用删除简历的操作

                  this.deleteResume()
                }).catch((err) => {
                  console.log(err)
                })


              } else {
                // 1600000  弹出异常
                this.$message.warning(data.msg)
                this.countDownForm.privacyChecked = true
              }

            })
            .catch(() => {
              this.countDownForm.privacyChecked = true
            })
        }

        //


      },

      // 删除简历
      deleteResume() {
        this.$request
          .get('/talent/talentresumemain/deleteResumeMainMT?userId=' + this.$route.query.userId, {})
          .then((res, total, code, data) => {
            if (data.code === 1) {
              this.$message.info('删除成功')
            } else {
              this.$message.warning(data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },

      // 简历政策子组件传递同意不同意
      resumePolicyEmit(data) {
        this.countDownForm.privacyChecked = data
      },

      // 倒计时开始
      getVerify() {
        const TIME_COUNT = 10; //更改倒计时时间
        if (this.countDownForm.show) {
          console.log(this.countDownForm)
          this.countDownForm.timer = setInterval(() => {
            if (this.countDownForm.count > 0 && this.countDownForm.count <= TIME_COUNT) {
              this.countDownForm.count--;
              this.countDownForm.s = 's'; //s
            } else {
              this.countDownForm.show = false;
              clearInterval(this.countDownForm.timer); // 清除定时器
              this.countDownForm.timer = null;
              this.countDownForm.count = null;// 0秒清除
              this.countDownForm.s = ''; //s清除
            }
          }, 1000);
        }
      },

      // 重置倒计时 Test使用
      resetShow() {
        this.countDownForm.show = true
        console.log(this.countDownForm)
      },

      // 主页面查询勾选城市树事件
      getcitySelectList(args) {
        let citys = args.split('~');
        this.dataForm.live = citys[0]
        this.dataForm.liveArr = []
        this.dataForm.liveName = citys[1]
        console.log(this.dataForm)
      },
      // 主页面查询勾选城市树事件
      getcitySelectList2(args) {
        let citys = args.split('~');
        this.dataForm['registeredResidence'] = citys[0]
        this.dataForm.registeredResidenceArr = []
        this.dataForm.registeredResidenceName = citys[1]
        console.log(this.dataForm)
      },
      // 主页面查询勾选城市树事件
      getcitySelectList3: function (args) {
        console.log(args)
        let citys = args.split('~');
        this.dataForm['nativePlace'] = citys[0]
        this.dataForm.nativePlaceArr = []
        this.dataForm.nativePlaceName = citys[1]
        console.log('籍贯')
        console.log(this.dataForm)
      },

      // 添加工作经历页面
      onAddworkExperienceFrom: function () {

        this.pickerOptionsStartAll.push(
          {
            pickerOptionsStart: {}
          }
        )
        this.pickerOptionsEndAll.push(
          {
            pickerOptionsEnd: {}
          }
        )

        this.workExperienceFrom.workExperience_list.push(
          {
            resumeMainId: this.dataForm.id,
            industryType: '10',
            industry: '',
            brandCode: '',
            otherBrandCodeName: '',
            company: '',
            job: '',
            startDate: '',
            endDate: '',
            jobDescription: '',
            itemNow: this.pickerOptionsStartAll.length - 1,
          }
        )

      },
      // 添加所获认证页面
      onAddAuthenticationFrom: function () {
        this.authenticationFrom.authentication_list.push(
          {
            archive: '',
            resumeMainId: this.dataForm.id,
            totalBrand: '',
            selectCertificateName: '',
            certificateGrade: '',
            yearGained: '',
          }
        )
      },
      // 添加教育背景页面
      onAddEducationalBackgroundFrom: function () {
        console.log('查看resumeMainId')
        console.log(this.dataForm.id)
        this.educationalBackgroundFrom.educationalBackground_list.push(
          {
            resumeMainId: this.dataForm.id,
            educationStartDate: '',
            educationEndDate: '',
            school: '',
            educationName: '',
            major: '',
          }
        )
        console.log(this.educationalBackgroundFrom.educationalBackground_list)
      },
      // 删除工作经历页面 --提示
      deleteworkExperienceFrom: function (item) {
        this.$confirm("确定删除工作经历吗？", '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
        }).then(() => {
          console.log("删除")
          this.deleteworkExperienceFromAction(item)
        }).catch(action => {
          console.log("取消")
          console.log(action)
        })
      },
      // 删除工作经历页面 --Action
      deleteworkExperienceFromAction: function (item) {
        console.log('删除工作经历')
        console.log(this.pickerOptionsStartAll)
        console.log(this.pickerOptionsEndAll)
        var index = this.workExperienceFrom.workExperience_list.indexOf(item)
        let work = this.workExperienceFrom.workExperience_list[index]
        if (index !== -1) {
          this.workExperienceFrom.workExperience_list.splice(index, 1)
          // this.pickerOptionsStartAll.splice(index, 1)
          // this.pickerOptionsEndAll.splice(index, 1)
        }
        if (work.id !== undefined) {
          this.delWorkInfo(work)
        }
        // 重新给开始结束时间赋时间限制
        // this.pickerOptionsStartAll = []
        // this.pickerOptionsEndAll = []

        // for(var i=0; i<this.workExperienceFrom.workExperience_list.length; i++){
        //   this.pickerOptionsStartAll.push(
        //     {
        //       pickerOptionsStart:{}
        //     }
        //   )
        //   this.pickerOptionsEndAll.push(
        //     {
        //       pickerOptionsEnd:{}
        //     }
        //   )
        //
        //   if(this.workExperienceFrom.workExperience_list[i].endDate !== '' && this.workExperienceFrom.workExperience_list[i].endDate !== undefined){
        //     this.pickerOptionsStartAll[i].pickerOptionsStart = Object.assign({}, this.pickerOptionsStartAll[i].pickerOptionsStart, {
        //       disabledDate: (time) => {
        //         let endDates = new Date(this.workExperienceFrom.workExperience_list[i].endDate)
        //         endDates.setMonth(endDates.getMonth() - 1);
        //         return time.getTime() > endDates
        //       }
        //     })
        //   }
        //
        //   if(this.workExperienceFrom.workExperience_list[i].startDate !== '' && this.workExperienceFrom.workExperience_list[i].startDate !== undefined){
        //     this.pickerOptionsEndAll[i].pickerOptionsEnd = Object.assign({}, this.pickerOptionsEndAll[i].pickerOptionsEnd, {
        //       disabledDate: (time) => {
        //         let startDates = new Date(this.workExperienceFrom.workExperience_list[i].startDate)
        //         startDates.setMonth(startDates.getMonth() + 1);
        //         return time.getTime() < startDates
        //       }
        //     })
        //   }
        // }


        console.log('删除工作经历-- 删除后')
        console.log(this.pickerOptionsStartAll)
        console.log(this.pickerOptionsEndAll)

      },
      // 删除所获认证页面 弹出框
      deleteAuthenticationFrom: function (item) {
        this.$confirm("确定删除所获认证吗？", '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
        }).then(() => {
          console.log("删除")
          this.deleteAuthenticationFromAction(item)
        }).catch(action => {
          console.log("取消")
          console.log(action)
        })
      },
      // 删除所获认证页面--Action
      deleteAuthenticationFromAction: function (item) {
        var index = this.authenticationFrom.authentication_list.indexOf(item)
        let authentication = this.authenticationFrom.authentication_list[index]
        if (index !== -1) {
          this.authenticationFrom.authentication_list.splice(index, 1)
        }
        if (authentication.id !== undefined) {
          this.delAuthentication(authentication)
        }

      },
      // 删除教育背景--提示
      deleteEducationalBackgroundFrom: function (item) {
        this.$confirm("确定删除教育背景吗？", '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning',
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
        }).then(() => {
          console.log("删除")
          this.deleteEducationalBackgroundFromAction(item)
        }).catch(action => {
          console.log("取消")
          console.log(action)
        })
      },
      // 删除教育背景--Action
      deleteEducationalBackgroundFromAction: function (item) {
        var index = this.educationalBackgroundFrom.educationalBackground_list.indexOf(item)
        let educational = this.educationalBackgroundFrom.educationalBackground_list[index]
        if (index !== -1) {
          this.educationalBackgroundFrom.educationalBackground_list.splice(index, 1)
        }
        if (educational.id !== undefined) {
          this.delEducational(educational)
        }

      },

      // 图片回掉函数
      refreshImg(data) {
        this.dataForm.headurl = data.url
        this.headId = data.userId
        this.userHeadurl = data.url
        this.headModifyShow = true
        // this.dataForm.idPhoto =
        let url = data.url
        let urlof = url.indexOf('img')
        url = url.substring(urlof)
        this.dataForm.idPhoto = url
        console.log('refreshImg')
        this.$eventHub.$emit(this.GLOBAL.HEADER_IMG, '')
        // 调用保存图片接口
        this.$request
          .post('/sys/commuser/app/updateHeadurlMT', {userId: this.$route.query.userId, headurl: data.url})
          .then((res, total, code, data) => {
            console.log(this.data)
          })
          .catch((err) => {
            console.log(err)
          })
      },
      // 图片编辑
      modifyImg() {
        console.log('点击图片编辑')
        this.modifyImgVisible = true
        this.$nextTick(() => {
          this.$refs.modifyImg.init(this.dataForm.userId)
        })
      },

      // 获取文件上的后的文件信息
      submitUploadSuccess(response, file, fileList, index) {
        console.log('获取文件上的后的文件信息')
        console.log(response)
        console.log(file)
        console.log(fileList)
        console.log(index)
        console.log(this.authenticUplad)
        console.log(this.authenticUpladIndex)
        if (response && response !== '') {
          console.log(this.authenticationFrom.authentication_list[this.authenticUpladIndex])
          this.authenticationFrom.authentication_list[this.authenticUpladIndex].archive = response.data
        }
        console.log(this.authenticationFrom)
      },
      // 点击附件列表的处理事件
      handlePreview(file) {
        console.log('handlePreview ')
        console.log(file)
        this.srcList = "";
        this.isShowImag = true;
        if(file.url === undefined || file.url === ''){
          this.srcList = 'https:'+file.response.data;
        }else {
          this.srcList = 'https:'+file.url
        }

      },
      resumeSubmitFile(item, index) {
        this.authenticUplad = item
        this.authenticUpladIndex = index
      },
      // 移除文件
      uploadBeforeRemove(file, fileList) {
        console.log('uploadBeforeRemove')
        console.log(file)
        const url = file.url

        for (var i = 0; i < this.dataForm.resumeAuthenticationDtoList.length; i++) {
          if (this.dataForm.resumeAuthenticationDtoList[i].archive === url) {
            console.log('删除啦。。。。')
            this.dataForm.resumeAuthenticationDtoList[i].archive = ''
          }
        }


        // this.authenticationFrom.authentication_list
        // this.fileList = []
        // this.dataForm.fileUpload = undefined
        // this.dataForm.fileName = ''
        // this.dataForm.fileId = ''
      },
      // 上传条数超出
      handleExceed(files, fileList) {
        this.$message.warning('只能选择一个文件。');
      },
      // //文件上传的校验
      beforeAvatarUpload(file) {
        let testmsg = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase()
        let uploadFormat = ['jpg', 'png']
        let falg = uploadFormat.indexOf(testmsg)
        if (falg === -1) {
          this.$message.warning('只能上传jpg/png文件')
          return false
        }
        // 上传文件限制4M
        let isLt2M = file.size / 1024 / 1024 <= 4
        if (!isLt2M) {
          this.$message.warning('上传文件大小不能超过 4MB!')
          return false
        }
      },
      // 下载文件
      downloadFile() {
        let requestUrl = window.SITE_CONFIG['apiBaseURL'] + '/rm/file/download' + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`
        let dlform = document.createElement('form')
        dlform.method = 'post'
        dlform.action = requestUrl
        let hdnFilePath = document.createElement('input')
        hdnFilePath.type = 'hidden'
        hdnFilePath.name = 'id'
        hdnFilePath.value = this.dataForm.fileId
        dlform.appendChild(hdnFilePath)
        document.body.appendChild(dlform)
        dlform.submit()
        document.body.removeChild(dlform)
      },
      // 查看证书图片
      viewImage(row) {
        this.srcList = "";
        this.isShowImag = true;
        this.srcList = row.archive;
      },
      startTimeStatus(index) {
        console.log('startTimeStatus')
        console.log(this.workExperienceFrom.workExperience_list[index])
      },
      // 跳转到预览页面  普通简历
      sendShowResume() {
        console.log('sendShowResume')
        console.log(this.$router)
        this.$eventHub.$emit('sendShowResume', '')
        this.$router.push({
          name: 'resume',
          query: {userId: this.userId}
        })
      },
      // 取消按钮
      cancelSendShowResume() {
        this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.sendShowResume()
        }).catch((err) => {
          console.log(err)
        })
      },
      // 取消按钮
      cancel() {
        this.$confirm('离开本页将不保存当前正在编辑的数据, 确定离开? ', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tabRemove()
          this.barkInfo()
        }).catch((err) => {
          console.log(err)
        })
      },
      // 返回页面
      barkInfo(){
        console.log('barkInfo')
        console.log(this.query.isAssessmentListNew)
        if(this.query.isAssessmentListNew === '0'){
          this.$router.push({
            name: 'acdc-resume-resumePDF',
            query: {
              userId: this.query.userId,
              jobName: this.query.jobName,
              orgName: this.query.orgName,
              recruitmentId:this.query.recruitmentId,
              isAssessmentListNew:this.query.isAssessmentListNew,
            }
          })

        }
        // 调用我的评估中心初始化方法
        this.$eventHub.$emit('assessmentListNew', '')
      },
      // 删除当前页面
      tabRemove() {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name})
        }
      },
    }
  }
</script>
<style lang='scss' scoped>
  // @import url(); 引入公共css类

  .img-div {
    text-align: center;
    width: 142px;
    margin-left: 7%;

    img {
      width: 100%;
      min-height: 100px;
    }

    .modify-img {
      cursor: pointer;
      margin-top: 10px;
    }
  }

  .picon {
    transform: translateX(-6%);
  }

  .bsicInfoTitle1 {
    text-align: center;
    display: inline-block;
    font-weight: 700;
    padding: 0 0.5%;
  }

  .bsicInfo {
    text-align: center;
    display: inline-block;
    color: #8fa3c6;
    font-size: 20px;
    padding: 0 0.5%;
  }

  .img-div {
    text-align: center;
    width: 142px;
  }

  .addToButton {
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url("../../../../assets/img/resume/个人简历-添加按钮-图标.png");
    background-size: 100% 100%;
    vertical-align: bottom;
  }

  .baseinfoico {
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url("../../../../assets/img/resume/个人简历-基本信息-图标.png");
    background-size: 100% 100%;
    vertical-align: bottom;
  }

  .personalEvaluate {
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url("../../../../assets/img/resume/个人简历-个人评价-图标.png");
    background-size: 100% 100%;
    vertical-align: bottom;
  }

  .workExperience {
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url("../../../../assets/img/resume/个人简历-工作经历-图标.png");
    background-size: 100% 100%;
    vertical-align: bottom;
  }

  .educationalBackground {
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url("../../../../assets/img/resume/个人简历-教育背景-图标.png");
    background-size: 100% 100%;
    vertical-align: bottom;
  }

  .personalSkills {
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url("../../../../assets/img/resume/个人简历-个人技能-图标.png");
    background-size: 100% 100%;
    vertical-align: bottom;
  }

  ::v-deep .el-textarea .el-input__count {
    bottom: -26px !important;
    right: auto;
  }


</style>
<style>
  .divcheckbox .el-checkbox {
    font-size: 14px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin-right: 3px;
  }
</style>
